import { FC } from 'react';
import CheckIcon from './CheckIcon';
import { PageHeroBullet, PageHeroTextStyle } from './PageHero.types';

const HeroContent: FC<{
  textStyle: PageHeroTextStyle;
  paragraph?: string;
  bullets: PageHeroBullet[];
}> = ({ textStyle, paragraph, bullets }) => {
  if (textStyle === 'paragraph' && paragraph) {
    return (
      <div
        className="text-white text-p1 mb-4 prose prose-invert max-w-none"
        dangerouslySetInnerHTML={{ __html: paragraph }}
      />
    );
  }

  return (
    <div className="flex flex-wrap">
      {bullets.map((bullet, index) => (
        <div key={`bullet-${index}`} className="flex w-full mb-[30px]">
          <div className="flex size-3 bg-citron-500 rounded-[50%] justify-center items-center mr-2 px-[4px] py-1">
            <CheckIcon />
          </div>
          <div className="flex text-white text-20/28">{bullet.label}</div>
        </div>
      ))}
    </div>
  );
};

export default HeroContent;
